module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quote"
  }, [_c('span', {
    staticClass: "points"
  }, [_vm._v(_vm._s(_vm.quote.ranking))]), _c('div', {
    staticClass: "quote-content"
  }, [(_vm.quote.author) ? _c('div', {
    staticClass: "quote-data"
  }, [_c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.quote.author.name))]), _c('span', {
    directives: [{
      name: "date",
      rawName: "v-date:date",
      value: (_vm.quote.dateTime),
      expression: "quote.dateTime",
      arg: "date"
    }],
    staticClass: "date"
  })]) : _vm._e(), (_vm.quote.externalAuthor) ? _c('div', {
    staticClass: "quote-data"
  }, [_c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.quote.externalAuthor))]), _c('span', {
    directives: [{
      name: "date",
      rawName: "v-date:date",
      value: (_vm.quote.dateTime),
      expression: "quote.dateTime",
      arg: "date"
    }],
    staticClass: "date"
  })]) : _vm._e(), _c('div', {
    staticClass: "quote-middle"
  }, [_c('p', [_vm._v(_vm._s(_vm.quote.quote))])]), _c('div', {
    staticClass: "quote-bottom"
  }, [_c('div', {
    staticClass: "votes"
  }, _vm._l((_vm.totalStars), function(n) {
    return _c('a', {
      staticClass: "vote",
      class: {
        stared: _vm.stars >= n
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.newVote(n)
        }
      }
    }, [_vm._v(" ")])
  })), _c('ul', {
    staticClass: "quote-actions"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showDeleteQuote()
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:cc": "http://creativecommons.org/ns#",
      "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      "xmlns:svg": "http://www.w3.org/2000/svg",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
      "width": "500",
      "height": "500",
      "viewBox": "0 0 500.00001 500.00001",
      "id": "svg2",
      "version": "1.1",
      "sodipodi:docname": "trash.svg"
    }
  }, [_c('defs', {
    attrs: {
      "id": "defs4"
    }
  }), _vm._v(" "), _c('sodipodi:namedview', {
    attrs: {
      "id": "base",
      "pagecolor": "#ffffff",
      "bordercolor": "#666666",
      "borderopacity": "1.0",
      "showgrid": "false",
      "units": "px"
    }
  }), _vm._v(" "), _c('metadata', {
    attrs: {
      "id": "metadata7"
    }
  }, [_c('rdf:RDF', [_c('cc:Work', {
    attrs: {
      "rdf:about": ""
    }
  }, [_c('dc:format', [_vm._v("\n          image/svg+xml\n        ")]), _vm._v(" "), _c('dc:type', {
    attrs: {
      "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "id": "layer1",
      "transform": "translate(0,-552.36216)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m207.72649 552.36246c-9.58156 0.56176-19.61044-0.5738-28.89232 2.18539-9.92365 4.51416-11.3996 16.74888-10.78194 26.35987-0.33982 10.57949-0.40206 21.16511-0.63311 31.74704-31.96322 0.55962-64.00768 0.0222-95.92 1.37682-15.647498 5.67343-28.108278 21.91494-25.377484 39.02559 0.472468 13.15448-1.671721 26.76164 1.361254 39.64406 5.091177 11.63453 15.950424 21.06625 28.48614 23.11997-1.357723 9.09644 0.351556 18.41407-0.240017 27.63358 0.445166 94.30366 0.163149 188.69761 1.17824 282.94502 5.738559 14.4077 19.891923 27.4604 36.319907 25.4936 94.83106 0.649 189.74702 0.6236 284.52771-0.074 14.70613-5.756 27.92148-20.249 25.93354-36.9377-0.0773-99.63186 0.57613-199.26439 0.75433-298.8967 16.57234-3.27329 31.36194-18.83844 29.43476-36.41906-0.28258-14.63241 2.02044-29.90795-2.19004-44.12704-6.07738-14.15728-21.45193-24.3356-37.10705-22.01057-27.34339-0.263-54.68677-0.52601-82.03016-0.78902-1.09277-16.83065 1.86004-34.59678-3.49927-50.91959-4.99968-9.00077-16.41929-9.84837-25.55076-9.09111-31.92454-0.5605-63.8489 0.18268-95.77373-0.26634zm42.31159 42.33448c13.16818 0 26.33636 0 39.50454 0 0 5.96369 0 11.92739 0 17.89108-26.42618-0.0534-52.94801 0.88329-79.31039-0.0725-0.11034-5.94023 0.0955-11.87974 0.19642-17.81861 13.20315 0 26.40628 0 39.60943 0zm122.56783 60.73089c12.14925 0.19476 24.63079-0.10751 36.48391 2.31314 6.00942 5.17744 1.59122 17.47034-6.88972 15.81431-96.25458 0.97257-192.53119 0.77479-288.7798 0.17031-7.60059-0.59965-16.113082 0.71039-23.093782-2.53865-4.724987-5.15244-1.499311-16.41916 6.498843-14.90503 91.921699-1.12566 183.858239-0.51093 275.780549-0.85408zm-122.56783 61.51275c43.72909 0 87.45818 0 131.18727 0-0.0737 95.93725 0.15656 191.94996-0.12395 287.84002-6.06281 8.2852-17.67534 4.0627-26.26609 5.1481-76.7573 0.6015-153.55808 0.4894-230.29033-0.4188-8.16139-3.5951-5.19383-14.38261-5.79459-21.38067-0.58279-90.39561 0.10852-180.79247 0.0947-271.18865 43.731 0 87.462 0 131.193 0zm-81.77418 51.35438c0.0229 72.69372-0.77901 145.38963 0.0286 218.08164 4.78253 7.62789 14.6676 4.18591 21.98694 4.89559 6.433-0.10899 12.86583-0.2277 19.29871-0.34368 0-74.86082 0-149.72164 0-224.58246-13.77015 0-27.54029 0-41.31044 0l-0.002 0.97636-0.002 0.97255zm61.11991 0c0.0199 72.68037-0.77296 145.3629 0.0286 218.04159 4.7362 7.69974 14.66739 4.19686 21.98693 4.93564 6.43363-0.10901 12.8671-0.2277 19.30062-0.34368 0-74.86082 0-149.72164 0-224.58246-13.77078 0-27.54156 0-41.31234 0l-0.002 0.97636-0.002 0.97255zm61.12183 0c0.0223 72.68037-0.77771 145.36292 0.0286 218.04159 4.73619 7.69974 14.66738 4.19686 21.98693 4.93564 6.43301-0.10899 12.86583-0.2277 19.29871-0.34368 0-74.86082 0-149.72164 0-224.58246-13.77015 0-27.54028 0-41.31043 0l-0.002 0.97636-0.002 0.97255z",
      "id": "path20103"
    }
  })])], 1)])]), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showEditQuote()
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "500",
      "height": "500",
      "viewBox": "0 0 499.99999 500.00001"
    }
  }, [_c('path', {
    staticStyle: {
      "block-progression": "tb",
      "isolation": "auto",
      "line-height": "normal",
      "mix-blend-mode": "normal",
      "text-align": "start",
      "text-decoration-color": "#000000",
      "text-decoration-line": "none",
      "text-decoration-style": "solid",
      "text-indent": "0",
      "text-transform": "none"
    },
    attrs: {
      "d": "M380.465 0L24.412 356.043l-.8 4.717L0 500l143.957-24.412L500 119.535 380.465 0zm0 42.426l29.64 29.64L89.793 392.37l-29.64-29.64L380.464 42.426zm47.318 47.318l29.79 29.79L137.27 439.85l-29.8-29.8L427.784 89.745zM49.513 387.447l63.038 63.037-51.6 8.75-20.29-19.58 8.854-52.207z",
      "font-family": "sans-serif",
      "solid-color": "#000000",
      "white-space": "normal"
    }
  })])])])])]), _c('div', {
    staticClass: "quote-comment"
  }, [_c('p', [_vm._v(_vm._s(_vm.quote.explanation))])])]), (_vm.deleteQuoteBox) ? _c('div', {
    staticClass: "delete-quote"
  }, [_c('span', [_vm._v("Delete Quote?")]), _c('div', {
    staticClass: "delete-btns"
  }, [_c('a', {
    staticClass: "btn-red",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideDeleteQuote()
      }
    }
  }, [_vm._v("Do not even think about it!")]), _c('a', {
    staticClass: "btn-green",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeQuote()
      }
    }
  }, [_vm._v("Yes, it's garbage")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-650913b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/Quote/Quote.pug
// module id = 263
// module chunks = 2